import { msalInstance } from "./msalInstance";
import { loginRequest } from "./authConfig";

export const getAccessToken = async (): Promise<string> => {

    try {
        // 🔥 WAIT until MSAL ready
        await msalInstance.initialize();

        const accounts = msalInstance.getAllAccounts();

        // 🔴 if not logged in → redirect
        if (accounts.length === 0) {
            await msalInstance.loginRedirect(loginRequest);
            return "";
        }

        // 🔥 get token silently
        const response = await msalInstance.acquireTokenSilent({
            ...loginRequest,
            account: accounts[0],
        });

        console.log("ACCESS TOKEN:", response.accessToken);

        return response.accessToken;

    } catch (error) {

        console.log("Silent token failed → redirect login");

        await msalInstance.loginRedirect(loginRequest);
        return "";
    }
};